module.exports = __webpack_public_path__ + "static/img/application7-2.f0b8e77.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/application/application7/application7-2.jpg
// module id = nC1L
// module chunks = 0